import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export interface likeItem {
  label: string;
  value: string | number;
}
export const selectLikeInputProps = buildProps({
  modelValue: {
    type: Object,
    required: true,
  },
  options: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  labelKey: {
    type: String,
    default: "text",
  },
  valueKey: {
    type: String,
    default: "id",
  },
  likeOptions: {
    type: definePropType<likeItem[]>(Array),
    default: () => [
      // TODO:国际化
      { label: "matchExact", value: 1 },
      { label: "matchFuzzy", value: 0 },
    ],
  },
  config: {
    type: Object,
    default: () => {
      return {
        key: "key",
        like: "searchType",
        value: "value",
      };
    },
  },
  leftWidth: {
    type: Number,
    default: 90,
  },
  rightWidth: {
    type: Number,
    default: 160,
  },
  noEmpty: {
    type: Boolean,
    default: false,
  },
  selectProps: {
    type: Object,
  },
} as const);
export type SelectLikeInputProps = ExtractPropTypes<
  typeof selectLikeInputProps
>;
